export enum TrackingContext {
  Attachments = 'attachments',
  AutomaticPaymentReminders = 'automatic_payment_reminders',
  BankAccountOverviewConnectBank = 'bank_account_overview_connect_bank',
  BankConnectionLimitsExceeded = 'bank_connection_limits_exceeded',
  BankConnectionsConnectBank = 'bank_connections_connect_bank',
  BankTransactions = 'bank_transactions',
  BillUpload = 'bill_upload',
  BillWidgetUpload = 'bill_widget_upload',
  CreateBillUpload = 'create_bill_upload',
  CreateContact = 'create_contact',
  CreateCustomer = 'create_customer',
  CreateQuote = 'create_quote',
  CreateRecurringInvoice = 'create_recurring_invoice',
  DaybookAttachment = 'daybook_attachment',
  DaybookIndex = 'daybook_index',
  InvoiceDiscount = 'invoice_discount',
  DepositInvoiceUpsellQuotesList = 'deposit_invoice_upsell_quotes_list',
  DepositInvoiceUpsellInvoicesList = 'deposit_invoice_upsell_invoices_list',
  DepositInvoiceUpsellQuoteDetails = 'deposit_invoice_upsell_quote_details',
  EditContact = 'edit_contact',
  EInvoice = 'e_invoice',
  EmailHigherRateExceeded = 'email_higher_rate_exceeded',
  EmailRateExceeded = 'email_rate_exceeded',
  FreeExpensesLimitExceeded = 'free_expenses_limit_exceeded',
  FreeInvoicesLimitExceeded = 'free_invoices_limit_exceeded',
  Integrations = 'integrations',
  InvoiceAttachment = 'invoice_attachment',
  InvoiceDesigner = 'invoice_designer',
  InvoiceEdit = 'invoice_edit',
  InvoiceMultiCurrency = 'invoice_multi_currency',
  InvoiceTemplateDesigner = 'invoice_template_designer',
  InvoiceTemplates = 'invoice_templates',
  OrganizationOwners = 'organization_owners',
  OrganizationSettingsUser = 'organization_settings_user',
  PaymentInformationEdit = 'payment_information_edit',
  PaymentMethodEditor = 'payment_method_editor',
  QuoteConvertToInvoice = 'quote_convert_to_invoice',
  SalarySignup = 'salary_signup',
  Scout = 'scout',
  ShineEInvoicing = 'shine_e_invoicing',
  SupplierAccountStatement = 'supplier_account_statement',
  SupplierAutomationRule = 'supplier_automation_rule',
  Uploads = 'uploads',
  VatHelper = 'vat_helper',
}
